import React, { useEffect, useState } from 'react'
import { Box, CardMedia, CircularProgress, Divider, Icon, Typography } from '@mui/material'
import defaultImage from 'assets/images/default_avatar.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { getAllEvaluationResult } from 'services/api/modules/performance/appraisal/result'
import { useQuery, useQueryClient } from 'react-query'
import { getAllSubmission } from 'services/api/modules/performance/appraisal/submission'

const ACDDrawerBody = ({ staff, appraisalId }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const queryClient = useQueryClient()
  const [staffId, setstaffId] = useState(staff?.staff_id)
  const [evaluations, setEvaluations] = useState([])
  const [uniqueEvaluations, setUniqueEvaluations] = useState([])
  useEffect(() => {
    queryClient.invalidateQueries(['allEvaluationResult', staffId, parseInt(appraisalId)])
    queryClient.resetQueries(['allEvaluationResult', staffId, parseInt(appraisalId)])
  }, [])

  const { isLoading } = useQuery(
    ['allEvaluationResult', staffId, appraisalId],
    async () => {
      const { data } = await getAllEvaluationResult(staffId, parseInt(appraisalId))
      return data
    },
    {
      onSuccess: async (res) => {
        Promise.all(
          res.map(async (evaluation) => {
            const { data } = await getAllSubmission(staffId, evaluation.evaluation_id)
            setEvaluations((evaluations) => [
              ...evaluations,
              { ...evaluation, evaluation_detail: data },
            ])
          })
        )
      },
      enabled: !!staffId,
    }
  )

  useEffect(() => {
    const filteredEvaluations = evaluations?.filter(
      (obj, index, self) =>
        index === self.findIndex((t) => t.evaluation_title === obj.evaluation_title)
    )

    filteredEvaluations.sort((a, b) => {
      return a.evaluation_id - b.evaluation_id
    })

    setUniqueEvaluations(filteredEvaluations)
  }, [evaluations])

  const handleView = (
    evalId,
    submissionId,
    evaluationTitle,
    evaluationScore,
    teamMemberDetails,
    reviewerLength
  ) => {
    navigate(`/app/appraisal-cycle/evaluation/${evalId}/${submissionId}/result`, {
      state: {
        ...state,
        item: { id: state?.id },
        evaluationDetails: {
          evaluation_title: evaluationTitle,
          evaluation_score: evaluationScore,
        },
        appraisalTabsValue: 2,
        teamMemberDetails,
        reviewerLength,
        submissionId: submissionId,
      },
    })
  }

  return (
    <>
      <Box px={3} py={2} display="flex" alignItems="center" gap={2}>
        <Box>
          <CardMedia
            component="img"
            sx={{
              height: 45,
              width: 45,
              objectFit: 'cover',
              borderRadius: '50%',
              marginRight: 2,
            }}
            src={staff.profile_image || defaultImage}
          />
        </Box>
        <Box display="flex" flexDirection="column">
          <Typography variant="h4">{staff?.name}</Typography>
          <Typography variant="body1" color="light-gray-text.main">
            {staff.designation}
          </Typography>
        </Box>
      </Box>
      <Divider />

      {isLoading ? (
        <Box height="30vh" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="alternate" size={60} />
        </Box>
      ) : (
        <Box>
          {uniqueEvaluations?.map((e, index) => {
            let reviewers
            if (!e?.evaluation_detail?.score) {
              reviewers = e?.evaluation_detail?.filter((detail) =>
                detail.roles.includes('reviewee')
              )
              reviewers.id = e?.evaluation_id
            } else {
              reviewers = e?.evaluation_detail?.score
            }
            if (reviewers.length !== 0) {
              return (
                <Box key={index}>
                  <Box
                    px={3}
                    py={2.5}
                    display="flex"
                    flexDirection={reviewers.length > 1 ? 'column' : 'row'}
                    sx={
                      reviewers.length > 1
                        ? null
                        : { alignItems: 'center', justifyContent: 'space-between' }
                    }
                    gap={2}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box
                        display="flex"
                        width={30}
                        height={30}
                        borderRadius="50%"
                        bgcolor={e?.evaluation_total_score ? 'light-yellow-01.main' : null}
                        justifyContent="center"
                        alignItems="center"
                        gap={2}
                      >
                        <Icon
                          sx={
                            e?.evaluation_total_score
                              ? {
                                  color: 'yellow-01.main',
                                  fontSize: '24px',
                                }
                              : {
                                  color: 'gray-inactive-button.main',
                                  fontSize: '24px',
                                }
                          }
                        >
                          workspace_premium
                        </Icon>
                      </Box>
                      <Typography
                        width={25}
                        variant="body1"
                        color={e.evaluation_total_score ? 'yellow-02.main' : 'light-gray-text.main'}
                      >
                        {e.evaluation_total_score
                          ? Math.round(e.evaluation_total_score * 50) / 10
                          : '--'}
                      </Typography>
                      <Typography variant="body1">{e.evaluation_title}</Typography>
                    </Box>
                    {reviewers.length > 1 ? (
                      reviewers?.map((r, index) => (
                        <Box
                          key={index}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box display="flex" gap={2}>
                            <Box width={30}></Box>
                            <Typography
                              width={25}
                              variant="body1"
                              color={r?.score ? 'yellow-02.main' : 'light-gray-text.main'}
                            >
                              {r?.score ? Math.round(r?.score * 50) / 10 : '--'}
                            </Typography>
                            <Typography variant="body1">Reviewer {index + 1}</Typography>
                          </Box>
                          {e?.is_external === 0 && (
                            <Typography
                              variant="body1"
                              color="alternate.main"
                              sx={{
                                width: 80,
                                textAlign: 'right',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                              }}
                              // onClick={() => handleView(r?.submission_id, e, r, reviewers?.length)}
                              onClick={() =>
                                handleView(
                                  r?.id,
                                  r?.submission_id,
                                  e.evaluation_title,
                                  r?.score,
                                  staff,
                                  reviewers.length
                                )
                              }
                            >
                              View
                            </Typography>
                          )}
                        </Box>
                      ))
                    ) : (
                      <>
                        {e?.is_external === 0 && (
                          <Typography
                            variant="body1"
                            color="alternate.main"
                            sx={{
                              width: 80,
                              textAlign: 'right',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                            // onClick={() => handleView(reviewers[0]?.submission_id, e, reviewers[0])}
                            onClick={() =>
                              handleView(
                                reviewers['id'],
                                reviewers[0]?.submission_id,
                                e.evaluation_title,
                                reviewers[0]?.score,
                                staff,
                                reviewers.length
                              )
                            }
                          >
                            View
                          </Typography>
                        )}
                      </>
                    )}
                  </Box>
                  <Divider />
                </Box>
              )
            }
          })}
        </Box>
      )}
    </>
  )
}

export default ACDDrawerBody
